var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V341.993H0V-0.00683594Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.993H256.5V-0.00683594H513V341.993H0V170.993Z",
    fill: "#00B2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.821 274.106L213.579 325.748L169.632 293.828H224.01L180.063 325.748L196.821 274.106ZM402.648 193.793L419.406 245.435L375.459 213.515H429.78L385.833 245.435L402.648 193.793ZM463.296 149.048L480.054 200.69L436.107 168.77H490.428L446.481 200.69L463.296 149.048ZM463.296 21.3113L480.054 72.9533L436.107 41.0333H490.428L446.481 72.9533L463.296 21.3113Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.443 -0.00683594V117.584H210.273L256.443 148.364V170.993H233.814L160.284 122.03V170.993H96.159V122.03L22.629 170.993H0V148.364L46.17 117.584H0V53.4592H46.17L0 22.7362V-0.00683594H22.629L96.159 48.9562V-0.00683594H160.284V48.9562L233.814 -0.00683594H256.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.267 -0.00683594H112.176V69.5332H0V101.567H112.176V170.993H144.267V101.567H256.443V69.5332H144.267V-0.00683594Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.443 22.7363V53.4593H210.273L256.443 22.7363Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.993V159.992L62.643 117.584H85.272L7.296 170.993H0ZM7.296 0.0500488L85.272 53.459H62.643L0 11.051V0.0500488H7.296ZM256.443 0.107049V11.108L193.8 53.459H171.171L249.147 0.107049H256.443ZM249.147 170.993L171.171 117.584H193.8L256.443 159.992V170.993H249.147Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.343 75.0051L427.101 126.647L383.154 94.7271H437.475L393.528 126.647L410.343 75.0051ZM332.88 106.982L349.638 158.624L305.691 126.704H360.012L316.065 158.624L332.88 106.982ZM349.98 245.435L366.738 297.077L322.791 265.157H377.112L333.165 297.077L349.98 245.435ZM278.16 189.233L294.918 240.875L250.971 208.955H305.292L261.345 240.875L278.16 189.233ZM278.16 264.473L294.918 316.115L250.971 284.195H305.292L261.345 316.115L278.16 264.473Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.23803e8abb5a58cf55b52f4355cae0e0.svg";
export { ForwardRef as ReactComponent };